/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Content_Title7Inputs */

const en_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI-written unique content`)
};

const ar_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`محتوى فريد مكتوب بالذكاء الاصطناعي`)
};

const bn_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এআই-লেখা অনন্য কনটেন্ট`)
};

const de_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KI-geschriebene einzigartige Inhalte`)
};

const es_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenido único escrito con IA`)
};

const fr_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Contenu unique rédigé par IA`)
};

const pt_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conteúdo único escrito com IA`)
};

const zh_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`AI 写的独特内容`)
};

const tr_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ ile benzersiz içerik`)
};

const ru_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Уникальный ИИ-контент`)
};

const pl_svc_programmatic_seo_content_title7 = /** @type {(inputs: Svc_Programmatic_Seo_Content_Title7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unikalne treści pisane przez AI`)
};

/**
* | output |
* | --- |
* | "AI-written unique content" |
*
* @param {Svc_Programmatic_Seo_Content_Title7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_content_title7 = /** @type {((inputs?: Svc_Programmatic_Seo_Content_Title7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Content_Title7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_content_title7(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_content_title7(inputs)
	if (locale === "de") return de_svc_programmatic_seo_content_title7(inputs)
	if (locale === "es") return es_svc_programmatic_seo_content_title7(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_content_title7(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_content_title7(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_content_title7(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_content_title7(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_content_title7(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_content_title7(inputs)
	return en_svc_programmatic_seo_content_title7(inputs)
});
export { svc_programmatic_seo_content_title7 as "svc_programmatic-seo_CONTENT_title" }